module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/055-scotland-d33fa447c7ba5a173a830c0269761a80.svg";